module.exports = __webpack_public_path__ + "img/eight6Blue.a67493ab.jpg";